import { getCexLabel } from "@cede/utils";
import { STEPS } from "@/store/connectStore";

export const STEPS_INFO = {
  [STEPS.ChooseCEX]: {
    title: {
      desktop: "Link the account you want to trade with",
      mobile: "Select CEX to connect",
    },
    subtitle: {
      desktop:
        "To get started, link the account you plan to use for trading. Once connected, you’ll be able to execute trades seamlessly through these accounts.",
      mobile: "",
    },
  },
  [STEPS.LinkAccount]: (cex: string) => ({
    title: {
      desktop: `Link your ${getCexLabel(cex)} account`,
      mobile: `Login to ${getCexLabel(cex)} account`,
    },
    subtitle: {
      desktop: `Securely connect your ${getCexLabel(cex)} account and start trading.
      Cede${"\u00A0"}Hub can never withdraw your funds.`,
      mobile: `You will be redirected to ${getCexLabel(cex)} to securely link your account to cede.hub`,
    },
  }),
  [STEPS.ApiKeys]: (cex: string) => ({
    title: {
      desktop: `Insert your ${getCexLabel(cex)} API keys`,
      mobile: `${getCexLabel(cex)} API keys`,
    },
    subtitle: {
      desktop: `Provide your public and private API Keys to finalize the connection to ${getCexLabel(cex)}.`,
      mobile: `Provide your public and private API Keys to finalize the connection to ${getCexLabel(cex)}.`,
    },
  }),
  [STEPS.LinkSocials]: {
    title: {
      desktop: "Link your social accounts",
      mobile: "Link your social accounts",
    },
    subtitle: {
      desktop: "Link at least one social account below to access the trading board",
      mobile: "Link at least one social account below to access the trading board",
    },
  },
};

export const RELINK_INFO = {
  [STEPS.ChooseCEX]: {
    title: {
      desktop: "Relink your account",
      mobile: "Relink your account",
    },
    subtitle: {
      desktop: "Unlink your account and link it again following the instructions.",
      mobile: "Unlink your account and link it again following the instructions.",
    },
  },
  [STEPS.LinkAccount]: (cex: string) => ({
    title: {
      desktop: `Relink your ${getCexLabel(cex)} account`,
      mobile: `Relink your ${getCexLabel(cex)} account`,
    },
    subtitle: {
      desktop: `Please link your account again, following the instructions to set correct permissions.`,
      mobile: `Please link your account again or use Desktop version of Cede${"\u00A0"}Hub to create new keys.`,
    },
  }),
  [STEPS.ApiKeys]: (cex: string) => ({
    title: {
      desktop: `Insert your ${getCexLabel(cex)} API keys with correct permissions`,
      mobile: "",
    },
    subtitle: {
      desktop: `Provide your public and private API Keys to finalize the connection to ${getCexLabel(cex)}.`,
      mobile: "",
    },
  }),
};

export const CONNECT_ACCOUNT_SNACKBAR_CONTENT = {
  title: (exchangeId: string) => (
    <>
      Wrong permissions! <br /> <b>Unlink</b> your {getCexLabel(exchangeId)} account and <b>link it again</b> with new
      keys
    </>
  ),
  subtitle: "Click here to open the settings and follow the instructions",
};
